import { CashNote } from "./cash-note";
import { CurrencySheet } from "./currency-sheet";
import { SystemField } from "./system-field";

export class CashNoteDetail extends SystemField{ 
     currency_sheets_id?:string;
     amount?:number;
     cash_note_id?:string;
     num_of_sheets?:string;

     //relatioship
     cash_note?:CashNote;
     currency_sheet?:CurrencySheet;
}
